import React from "react";
export default class Dcma extends React.Component {
     render(){
         return <div style={{background:'green'}}>this list</div>
     }
}